<app-hire-sidebar></app-hire-sidebar>

<div>
  <div class="hire-search-card">
    <div class="d-flex align-items-center justify-content-start">
        <label class="wc-checkbox mb-0 mr-3">
          <input data-testid="auto-app-my-candidates-input-1" type="checkbox" id="mycheck" name="mycheck" (change)="selectAll($event)"
            [(ngModel)]="selectAllChecked">
          <i class="fas fa-check" style="border-color: #2e93a1 ;"></i>
        </label>
        <div class="mr-2">
          <input data-testid="auto-app-my-candidates-input-2" style="width: 300px;" type="text" class="wc-form-control nobg" #candidatenameInput [matAutocomplete]="candidatename"
           [formControl]="searchInput" (input)="onSearchInput($event)" (keydown.enter)="selectOption($event.target.value, 'enter')"
            placeholder="Search Candidate">
                <mat-autocomplete #candidatename="matAutocomplete"
                    (optionSelected)="selectOption($event.option.value)">
                    <mat-option *ngFor="let name of candidateNameRes" [value]="name">{{name.fullname | titlecase}} <span>
                        </span>
                    </mat-option>
                  </mat-autocomplete>
        </div>
        <button data-testid="auto-app-my-candidates-button-1" class="filter-criteria-cta pointer" (click)="openFilterModal()">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
              <path
                d="M8.16593 12C8.09108 11.9999 8.01672 11.988 7.94572 11.9645L5.60803 11.1952C5.469 11.149 5.34824 11.0606 5.2629 10.9427C5.17755 10.8247 5.13196 10.6831 5.13261 10.5381V7.09932C5.132 7.09791 5.13111 7.09664 5.12999 7.09558L0.211057 1.42904C0.101985 1.30337 0.0316669 1.14938 0.00845045 0.985361C-0.014766 0.821341 0.0100946 0.654176 0.0800807 0.503715C0.150067 0.353253 0.262239 0.225813 0.403279 0.136526C0.544319 0.0472391 0.708303 -0.00014463 0.875762 3.31615e-07H13.1242C13.2917 -0.00014463 13.4557 0.0472391 13.5967 0.136526C13.7378 0.225813 13.8499 0.353253 13.9199 0.503715C13.9899 0.654176 14.0148 0.821341 13.9915 0.985361C13.9683 1.14938 13.898 1.30337 13.7889 1.42904L8.86855 7.09615C8.86758 7.09733 8.8667 7.09859 8.86593 7.0999V11.3077C8.8662 11.3987 8.84828 11.4888 8.81319 11.5729C8.77811 11.6571 8.72656 11.7335 8.6615 11.7978C8.59645 11.8622 8.51918 11.9131 8.43413 11.9478C8.34908 11.9825 8.25793 12.0003 8.16593 12Z"
                fill="#484B59" />
            </svg>
          </span>
          <span class="mx-2">
            Filters
          </span>
          <span class="fl-count" *ngIf="pipelineFilterCount > 0">
            {{pipelineFilterCount}}
          </span>
        </button>
      </div>

      <div class="d-flex align-items-center">
          <div class="d-flex align-items-center mr-2">
            <span>
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.6668 15.5837V17.417H1.8335V15.5837C1.8335 15.5837 1.8335 11.917 8.25016 11.917C14.6668 11.917 14.6668 15.5837 14.6668 15.5837ZM11.4585 6.87536C11.4585 6.24081 11.2703 5.62051 10.9178 5.0929C10.5653 4.5653 10.0642 4.15408 9.47794 3.91125C8.89169 3.66841 8.2466 3.60488 7.62425 3.72867C7.00189 3.85247 6.43022 4.15803 5.98153 4.60673C5.53284 5.05542 5.22727 5.62709 5.10348 6.24944C4.97968 6.8718 5.04322 7.51689 5.28605 8.10313C5.52888 8.68938 5.9401 9.19045 6.46771 9.54299C6.99532 9.89553 7.61561 10.0837 8.25016 10.0837C9.10107 10.0837 9.91712 9.74567 10.5188 9.14399C11.1205 8.54231 11.4585 7.72626 11.4585 6.87536ZM14.6118 11.917C15.1753 12.3531 15.6365 12.9074 15.9627 13.5409C16.2889 14.1744 16.4724 14.8717 16.5002 15.5837V17.417H20.1668V15.5837C20.1668 15.5837 20.1668 12.2562 14.6118 11.917ZM13.7502 3.66703C13.1193 3.66409 12.5024 3.85268 11.981 4.20786C12.5378 4.98587 12.8372 5.91862 12.8372 6.87536C12.8372 7.8321 12.5378 8.76485 11.981 9.54286C12.5024 9.89804 13.1193 10.0866 13.7502 10.0837C14.6011 10.0837 15.4171 9.74567 16.0188 9.14399C16.6205 8.54231 16.9585 7.72626 16.9585 6.87536C16.9585 6.02446 16.6205 5.2084 16.0188 4.60673C15.4171 4.00505 14.6011 3.66703 13.7502 3.66703Z"
                  fill="#5E5E5E" />
              </svg>
              @if(!selectedCandidateIds.size) {
                <span class="ml-2 f-12 font-weight-500">{{formatNumberToIndianFormat(totalCandidatesCount)}}
                Talents</span>
              }
              @if (selectedCandidateIds.size > 0) {
                <span class="ml-2 f-12 font-weight-500">{{ selectedCandidateIds.size
                  }} of {{ totalCandidatesCount }}
                  Selected</span>
              }
            </span>
          </div>

          @if(selectedCandidateIds.size > 0) {
          <div class="d-flex align-items-center">
             <app-add-to-campaign [campaignList]="campaignList" [type]="'bulk'" [candidates]="selectedCandidatesFull"
              [calledFrom]="'project-details-pipeline-view'"></app-add-to-campaign>
            <app-add-to-pipeline type="bulk" [projectList]="projectList" [candidateid]="candidate?.id" [calledFrom]="'my-candidates'" [criteriaChips]="criteriaChips" [selectedCandidates]="selectedCandidateIdsArray"></app-add-to-pipeline>
          </div>
          } @else{
            <div class="last-activity ml-1 dropdown-caret" [ngClass]="{'bg-img-rotate-caret': isOpen, '':!rotateCaret}">
              <select data-testid="auto-app-my-candidates-select-1" class="wc-form-control no-shadow f-12 custom-select"   #selectRef (change)="onFilterChange($event); adjustWidth(selectRef)" (focus)="isOpen = true" (click)="isOpen=true"
        (blur)="isOpen = false" style="width: 125px;">
                <option value="" disabled>Last activity</option>
                <option value="new">Recently Added</option>
                <option value="old">Oldest Added</option>
                <option value="ascendingbyname">Name (A to Z)</option>
                <option value="descendingbyname">Name (Z to A)</option>
              </select>
            </div>
          }

          <!-- three-dots menu, same as the pipeline / search pages -->
          <div class="pipeline-export-dropbtn ml-2" ngbDropdown placement="bottom-end" container="body">
            <button data-testid="auto-app-my-candidates-button-2" class="pipeline-export-toggle" type="button" id="myCandidatesMoreDropdown" ngbDropdownToggle
              aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu pipeline-export-menu" ngbDropdownMenu aria-labelledby="myCandidatesMoreDropdown">
              <a data-testid="auto-app-my-candidates-a-1" class="dropdown-item pipeline-export-item" ngbDropdownItem (click)="openBulkRevealScopeModal()">
                <span>Bulk Reveal Contact</span>
              </a>
            </div>
          </div>
        </div>
  </div>

  @if(showProjectCandidateListLoader) {
  <app-hire-skeleton-loaders [candidateListLoader]=true></app-hire-skeleton-loaders>
 } @else {

 @for (candidate of allCandidates; track candidate.candidateid; let i = $index) {
  <app-hire-candidate-card [candidate]="candidate" [index]="i" (childEvents)="handleChildEvent($event)" [calledFrom]="'my-candidates'"
     [campaignList]="campaignList" [isChecked]="selectedCandidateIds.has(candidate?.basicdetails?.candidatenumber)"
    (selectionChange)="onSelectionChange($event)" [stageList]="stageList" [projectList]="projectList"
    ></app-hire-candidate-card>
 }

 @if(allCandidates?.length === 0 && !showProjectCandidateListLoader) {
  <div class="recommended-empty-screen">
    <p class="f-16 font-weight-600 text-center">No candidates found</p>
    <p class="f-12 font-weight-400 text-center line-height-1">As you add candidates to your pipeline, they'll appear here for easy tracking and management.</p>

  </div>
}
 }
 @if(totalCandidatesCount > 20) {
 <div class="d-flex justify-content-center align-items-center hire-card">
        <ngb-pagination [collectionSize]="totalCandidatesCount" [maxSize]="5"
        [pageSize]="20" [rotate]="true" (pageChange)="setPage($event)" [page]="currentPage">
        <ng-template ngbPaginationPrevious> <span>Prev</span></ng-template>
        <ng-template ngbPaginationNext> <span
          >Next</span>
        </ng-template>
      </ngb-pagination>
       </div>
      }

</div>

<ng-template #bulkRevealScopeModal>
  <div class="modal-content pipeline-export-modal-content">
    <div class="modal-header pb-2">
      <h5 class="f-14 font-weight-600 mb-0" id="bulkRevealScopeModalHeading">Bulk Reveal Contact</h5>
      <button data-testid="auto-app-my-candidates-button-3" type="button" class="btn-close" aria-label="Close" (click)="dismissBulkRevealScopeModal()"></button>
    </div>
    <div class="modal-body pipeline-export-options pt-1 pb-2">
      <a data-testid="auto-app-my-candidates-a-2" class="pipeline-export-option" [class.disabled]="!selectedCandidateIds.size || loadingRevealPreview.selected"
        (click)="selectedCandidateIds.size && revealScope('selected')">
        <span class="pipeline-export-option-icon"><i class="fa-solid fa-square-check"></i></span>
        <span class="d-flex flex-column">
          <span>Selected ({{ selectedCandidateIds.size }})</span>
          @if (loadingRevealPreview.selected) {
            <small class="text-muted">Checking eligibility...</small>
          }
          @if (!loadingRevealPreview.selected && revealPreview.selected; as preview) {
            <small class="text-muted">
              {{ preview.alreadyRevealed.length }} already revealed, {{ preview.pending.length }} pending request{{ preview.pending.length === 1 ? '' : 's' }}
            </small>
          }
        </span>
      </a>
      <a data-testid="auto-app-my-candidates-a-3" class="pipeline-export-option" [class.disabled]="loadingRevealPreview.currentPage" (click)="revealScope('currentPage')">
        <span class="pipeline-export-option-icon"><i class="fa-solid fa-file-lines"></i></span>
        <span class="d-flex flex-column">
          <span>Current page ({{ allCandidates.length }})</span>
          @if (loadingRevealPreview.currentPage) {
            <small class="text-muted">Checking eligibility...</small>
          }
          @if (!loadingRevealPreview.currentPage && revealPreview.currentPage; as preview) {
            <small class="text-muted">
              {{ preview.alreadyRevealed.length }} already revealed, {{ preview.pending.length }} pending request{{ preview.pending.length === 1 ? '' : 's' }}
            </small>
          }
        </span>
      </a>
    </div>
  </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" style="background-color: yellow !important;" *ngIf="infoMessage" type="info"
  (close)="infoMessage = ''">
  <span class="infoCheck"><i class="fal fa-info-circle"></i></span>
  <span class="infomsg ml-1">{{ infoMessage }}</span>
</ngb-alert>
